/** 32 hex chars (no dashes) → canonical GUID string for APIs expecting Guid. */
export function toDashedGuid32(normalized32: string): string | null {
  const n = normalized32.toLowerCase();
  if (n.length !== 32 || !/^[0-9a-f]{32}$/.test(n)) return null;
  return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20, 32)}`;
}

export function visitUlidToApiGuid(visitULID: string | undefined): string | null {
  if (!visitULID) return null;
  return toDashedGuid32(normalizeGuid(visitULID));
}

export function normalizeGuid(guid: any): string {
  if (!guid) return '';
  return String(guid).toLowerCase().trim().replace(/[{}-\s]/g, '');
}

export function compareGuids(guid1: any, guid2: any): boolean {
  return normalizeGuid(guid1) === normalizeGuid(guid2) && normalizeGuid(guid1) !== '';
}
